module.exports = __webpack_public_path__ + "assets/img/llsj3.cca8ff25.jpg";